/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  SpanWithData,
  LabelledDetail,
  Grid,
  DisplayAmount
} from '../'

import {
  getHealthLevelName
} from '../../utils'


const getLastHealthLevels = (healthLevelHistory ) => {
  let lastThreeNumbers = healthLevelHistory.slice(-3)

  let lastThreeLevelNames = lastThreeNumbers.map(number => getHealthLevelName(number))

  return lastThreeLevelNames.join(', ')
}

export const CreditInputs = ({ membershipStatus, earnbacksStatus, clientEmploymentType, picsaMembershipLength,
  earnbacksMembershipLength, healthLevelHistory, clientSalaryMonthly, clientSalaryCycle, employerCreditMultiplier,
  balanceShorttermInvestedIncl, balanceLongtermInvestedIncl, earnbacksBalance, investmentShortClientMonthlyContribution,
  investmentLongClientMonthlyContribution, className}) => (
  <div className={className}>
    <div className='u-font-size-larger u-font-weight-bold'>
      Inputs:
    </div>
    <div className='slds-m-bottom_large'>
      <Grid
        items={[
          <LabelledDetail
            label='Picsa membership'
            detail={membershipStatus
              ? <SpanWithData forField='IdentityMembershipStatus' searchKey={membershipStatus} />
              : 'Unknown'
            }
          />,
          <LabelledDetail
            label='Number of months (Picsa member)'
            detail={picsaMembershipLength}
          />,
          <LabelledDetail
            label='EarnBacks membership'
            detail={earnbacksStatus
              ? <SpanWithData forField='IdentityEarnbacksStatus' searchKey={earnbacksStatus} />
              : 'Unknown'
            }
          />,
          <LabelledDetail
            label='Number of months (EarnBacks member)'
            detail={earnbacksMembershipLength}
          />,
          <LabelledDetail
            label='Employment status'
            detail={clientEmploymentType
              ? <SpanWithData forField='ClientEmploymentType' searchKey={clientEmploymentType} />
              : 'Unknown'
            }
          />,
          <LabelledDetail
            label='Employer multiplier'
            detail={employerCreditMultiplier}
          />,
          <LabelledDetail
            label='Monthly salary'
            detail={<DisplayAmount amountString={clientSalaryMonthly} />}
          />,
          <LabelledDetail
            label='Salary per payroll cycle'
            detail={<DisplayAmount amountString={clientSalaryCycle} />}
          />,
          <LabelledDetail
            label='Financial health level'
            detail={getLastHealthLevels(JSON.parse(healthLevelHistory))}
          />
        ]}
        itemClassName='slds-m-top_small slds-p-bottom_x-small'
      />

      <div className='slds-m-top_medium'>
        <div className='u-font-weight-bold'>
          Investment balances:
        </div>
        <Detail label='Short-term investments'>
          {balanceShorttermInvestedIncl
            ? <DisplayAmount amountString={balanceShorttermInvestedIncl} />
            : 'Unknown'
          }
        </Detail>
        <Detail label='Long-term investments'>
          {balanceLongtermInvestedIncl
            ? <DisplayAmount amountString={balanceLongtermInvestedIncl} />
            : "Unknown"
          }
        </Detail>
        <Detail label='EarnBacks points'>
          {earnbacksBalance || "Unknown"}
        </Detail>
      </div>

      <div className='slds-m-top_medium'>
        <div className='u-font-weight-bold'>
          Monthly investment contributions:
        </div>
        <Detail label='Short-term investments'>
          {investmentShortClientMonthlyContribution
            ? <DisplayAmount amountString={investmentShortClientMonthlyContribution} />
            : 'Unknown'
          }
        </Detail>
        <Detail label='Long-term investments'>
          {investmentLongClientMonthlyContribution
            ? <DisplayAmount amountString={investmentLongClientMonthlyContribution} />
            : 'Unknown'
          }
        </Detail>
      </div>
    </div>
  </div>
)

CreditInputs.propTypes = {
  membershipStatus: PropTypes.string,
  earnbacksStatus: PropTypes.string,
  clientEmploymentType: PropTypes.string,
  membershipSignupOn: PropTypes.string,
  earnbacksSignupOn: PropTypes.string,
  healthLevelHistory: PropTypes.arrayOf(PropTypes.number),
  clientSalary: PropTypes.string
}

CreditInputs.defaultProps = {
  className: ''
}

const Detail = ({ label, children }) => (
  <dl className='slds-list_horizontal slds-wrap'>
    <dt className='slds-item_label slds-text-color_weak'>
      {label}
    </dt>
    <dd className='slds-item_detail slds-truncate'>
      {children}
    </dd>
  </dl>
)



// WEBPACK FOOTER //
// ./src/components/creditapplication-modal/CreditInputs.js